
import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-6 py-20">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80">
            Om os
          </h1>
          
          <div className="prose prose-lg">
            <p className="mb-6">
              Abonemt er din pålidelige guide til at finde det perfekte mobilabonnement. Vi er dedikerede til at gøre processen med at vælge mobilabonnement så nem og gennemskuelig som mulig.
            </p>
            
            <p className="mb-6">Vores platform sammenligner abonnementer fra populære teleselskaber, så du nemt kan få overblik over de bedste tilbud. Vi opdaterer dagligt vores database for at sikre, at du altid har adgang til de nyeste priser og tilbud.</p>
            
            <p className="mb-6">Vores mål er at hjælpe dig med at træffe det bedste valg baseret på dine behov og præferencer.</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default About;
